<template>
  <div id="app">
    <splash-screen v-if="!initialized" @configurationLoaded="appLoaded"/>
    <maintenance-page v-else-if="initialized && maintenanceModeEnabled"/>
    <router-view v-else/>
    <div id="modals-container"></div>
    <BiometricLoginPrompt v-if="showBiometryLoginOption"/>
    <BiometricLoginError v-if="showBiometryLoginOption"/>
    <Toasts></Toasts>
  </div>
</template>
<script>
import Toasts from '@shared/components/Toasts'
import SplashScreen from '@shared/pages/SplashScreen'
import MaintenancePage from '@shared/pages/MaintenancePage'
import PushNotificationMixin from '@shared/mixins/PushNotificationMixin'
import BiometricLoginMixin from '@shared/mixins/BiometricLoginMixin'
import BiometricLoginPrompt from '@shared/pages/BiometricLoginPrompt'
import BiometricLoginError from '@shared/pages/BiometricLoginError'
import store from '@shared/store'
import settings from '@shared/settings'
import chat, { showChatBubble } from '@shared/module/chat'

export default {
  components: { BiometricLoginPrompt, BiometricLoginError, MaintenancePage, SplashScreen, Toasts },
  mixins: [PushNotificationMixin, BiometricLoginMixin],
  data() {
    return {
      initialized: false
    }
  },
  created() {
    this.$root.$on('push-notification-received', this.handlePushNotification)
    if (settings.featureFlags.isChatEnabled() && settings.isDesktopWeb()) {
      chat()
      showChatBubble()
    }
  },
  methods: {
    appLoaded() {
      this.initialized = true
      store.setInitialized()
    }
  },
  computed: {
    showBiometryLoginOption() {
      return settings.isPkiSigningSupported() && settings.featureFlags.isBiometricLoginEnabled()
    },
    maintenanceModeEnabled() {
      return this.$configuration && !!this.$configuration.maintenanceModeEnabled
    }
  },
  errorCaptured(error, vm, info) {
    const request = {
      name: error.name,
      message: error.message,
      info: info,
      location: window.location.href,
      route: this.$route.name,
      source: vm && vm.$options && vm.$options._componentTag,
      stack: String(error.stack || error)
    }
    this.$http.post('/api/log', request, { headers: { 'Content-Type': 'text/plain' } })
        .catch((loggingError) => {
          console.error('failed to log JS Error:', loggingError, 'info', info, 'error', error)
        })
  }
}
</script>
